/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const CmpWorkoutcard = ({ state, className }) => {
  return (
    <div className={`cmp-workoutcard ${className}`}>
      <p className="text-wrapper">Week 2 • Day 1</p>

      <div className="div">1 km Easy Run</div>
    </div>
  );
};

CmpWorkoutcard.propTypes = {
  state: PropTypes.oneOf(["live"]),
};
